import { useState } from "react"
import {
  Microphone,
  MicrophoneSlash,
  PhoneDisconnect,
  Subtitles,
  SubtitlesSlash,
  VideoCamera,
  VideoCameraSlash,
} from "@phosphor-icons/react"
import { LocalParticipant } from "twilio-video"
import { Button } from "@/components/ui/button"
import { LocalVideo } from "@/modules/video-call/components/local-video"
import { ParticipantVideo } from "@/modules/video-call/components/participant-video"
import { VideoCallCompleted } from "@/modules/video-call/components/video-call-completed"

type VideoCallProps = {
  isDisconnected: boolean
  handleCloseVideoCall: VoidFunction
  localParticipant?: LocalParticipant | null
  isSpeechToTextEnabled: boolean
  showTranscript: boolean
  onToggleTranscript: VoidFunction
  onMicrophoneToggle: (isMuted: boolean) => void
}

export const VideoCall = (props: VideoCallProps) => {
  const { isDisconnected, localParticipant } = props
  const [isMicrophoneEnabled, setIsMicrophoneEnabled] = useState(true)
  const [isCameraEnabled, setIsCameraEnabled] = useState(true)

  const toggleCameraEnabled = () => {
    setIsCameraEnabled((prev) => !prev)

    if (localParticipant) {
      localParticipant.videoTracks.forEach((videoTrack) => {
        const localTrack = videoTrack.track
        if (localTrack.isEnabled) localTrack.disable()
        else localTrack.enable()
      })
    }
  }
  const toggleMicrophoneEnabled = () => {
    const willBeMuted = isMicrophoneEnabled
    setIsMicrophoneEnabled((prev) => !prev)

    if (localParticipant) {
      localParticipant.audioTracks.forEach((audioTrack) => {
        const localTrack = audioTrack.track
        if (localTrack.isEnabled) localTrack.disable()
        else localTrack.enable()
      })
    }

    props.onMicrophoneToggle(willBeMuted)
  }

  if (isDisconnected) {
    return <VideoCallCompleted />
  }

  return (
    <>
      <ParticipantVideo />
      {isCameraEnabled ? (
        <LocalVideo />
      ) : (
        <div className="absolute top-4 right-4 flex h-50 w-50 items-center justify-center rounded-md border border-white bg-black text-white">
          <VideoCameraSlash />
        </div>
      )}
      <div className="sticky bottom-4 left-[50%] flex items-center justify-center gap-2">
        <Button
          variant="circle"
          className="bg-critical hover:bg-critical-hovered active:bg-critical-pressed h-10 w-10"
          onClick={props.handleCloseVideoCall}>
          <PhoneDisconnect className="text-white!" size={24} />
        </Button>
        <Button variant="circle" className="h-10 w-10 border border-white" onClick={toggleMicrophoneEnabled}>
          {isMicrophoneEnabled ? (
            <Microphone className="text-white!" size={24} />
          ) : (
            <MicrophoneSlash className="text-white!" size={24} />
          )}
        </Button>
        <Button variant="circle" className="h-10 w-10 border border-white" onClick={toggleCameraEnabled}>
          {isCameraEnabled ? (
            <VideoCamera className="text-white!" size={24} />
          ) : (
            <VideoCameraSlash className="text-white!" size={24} />
          )}
        </Button>
        {props.isSpeechToTextEnabled && (
          <Button variant="circle" className="h-10 w-10 border border-white" onClick={props.onToggleTranscript}>
            {props.showTranscript ? (
              <Subtitles className="text-white!" size={24} />
            ) : (
              <SubtitlesSlash className="text-white!" size={24} />
            )}
          </Button>
        )}
      </div>
    </>
  )
}
